export default __webpack_public_path__ + "static/media/onboarding2.c1ad3ca2.gif";